import { Card, IconGhostWaveWall } from '@veneer/core';
import tokens from '@veneer/tokens';
import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${tokens.layout.size1};

  && {
    h4 {
      font-size: ${tokens.typography.size7};
    }
  }
`;

export const NoDevicesSection = styled(Card)`
  display: flex;
  flex-direction: column;

  && {
    padding: ${tokens.layout.size4};
    border-radius: ${tokens.layout.size4};
  }
`;

export const NoDevicesSectionContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${tokens.typography.size9};
`;

export const IconGhost = styled(IconGhostWaveWall)`
  && {
    color: ${tokens.color.gray9};
  }
`;

export const NoDevices = styled.span`
  color: ${tokens.color.gray9};
  font-size: ${tokens.typography.size2};
  line-height: ${tokens.typography.size5};
`;

export const DevicesContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  max-width: 1140px;
  gap: ${tokens.layout.size3};
`;

export const DevicesList = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${tokens.layout.size5};

  @media screen and (max-width: 833px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

export const RefreshSection = styled.div`
  display: flex;
  justify-content: center;
`;

export const SubSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
